import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Order from "./pages/Order";
import Subscribe from "./pages/Loginin";
import Stats from "./pages/Signin";

const App = () => {
    return (
        <Router>
            {/* 顶部导航栏，固定在页面顶部 */}
            <nav className="bg-gray-900 text-white py-4 px-6 flex justify-between items-center fixed top-0 left-0 w-full z-50">
                <h1 className="text-2xl font-bold text-yellow-400">超美味</h1>
                <div className="space-x-6">
                    <Link to="/" className="text-white hover:text-yellow-400">首页</Link>
                    <Link to="/products" className="text-white hover:text-yellow-400">产品展示</Link>
                    <Link to="/order" className="text-white hover:text-yellow-400">订购</Link>
                    <Link to="/loginin" className="text-white hover:text-yellow-400">登录</Link>
                    <Link to="/signin" className="text-white border border-white px-4 py-2 rounded hover:text-yellow-400 hover:border-yellow-400">
                        注册
                    </Link>
                </div>
            </nav>

            {/* 页面内容，需要加 margin-top，防止被导航栏遮挡 */}
            <div className="mt-16">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/order" element={<Order />} />
                    <Route path="/loginin" element={<Subscribe />} />
                    <Route path="/signin" element={<Stats />} />
                </Routes>
            </div>
        </Router>
    );
};

export default App;
